import { render, staticRenderFns } from "./ot-loading-spinner.vue?vue&type=template&id=5ccfc729&scoped=true&"
import script from "./ot-loading-spinner.vue?vue&type=script&lang=ts&"
export * from "./ot-loading-spinner.vue?vue&type=script&lang=ts&"
import style0 from "./ot-loading-spinner.vue?vue&type=style&index=0&id=5ccfc729&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccfc729",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
